<template>
  <v-container v-if="loaded" class="minHeight">
    <v-card v-if="!hasRows" class="py-4">
      <advice color="warning">
        <p v-html="$t('profile.platesList.noPlates')"></p>
      </advice>
      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>

        <v-btn
          round
          flat
          color="accent"
          class="capitalize"
          outline
          @click="
            isShowingPlateCreateBottomSheet = !isShowingPlateCreateBottomSheet
          "
        >
          {{ $t('plates.createPlate.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-flex xs12 class="py-4">
        <advice color="primary">
          <p v-html="$t('profile.platesList.advice')"></p>
        </advice>
      </v-flex>
      <v-layout row class="pb-4">
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="plates"
            hide-actions
            expand
            item-key="code"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.code }}</td>
              <td class="text-xs-right">{{ props.item.alias }}</td>
              <td class="justify-center layout px-0">
                <v-btn
                  icon
                  class="error"
                  color="error"
                  outline
                  @click="showPlateDeleteDialog(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>

        <v-btn
          round
          flat
          color="accent"
          class="capitalize"
          outline
          @click="
            isShowingPlateCreateBottomSheet = !isShowingPlateCreateBottomSheet
          "
        >
          {{ $t('plates.createPlate.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <delete-plate
      v-if="isShowingPlateDeleteDialog"
      :plate="selectedPlate"
      @on-success="getuserPlates"
      @on-close="closePlateDeleteDialog"
    ></delete-plate>

    <create-plate
      v-if="isShowingPlateCreateBottomSheet"
      @on-success="getuserPlates"
      @on-close="closePlateCreateBottomSheet"
    ></create-plate>
  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import plateService from '@/services/plateService';
import manageErrorService from '@/services/manageErrorService';
import CreatePlate from '@/components/private/user/CreatePlate';
import DeletePlate from '@/components/private/user/DeletePlate';
export default {
  name: 'PlatesList',
  components: {
    [Advice.name]: Advice,
    [CreatePlate.name]: CreatePlate,
    [DeletePlate.name]: DeletePlate
  },
  data() {
    return {
      loaded: false,
      hasRows: false,
      isShowingPlateCreateBottomSheet: false,
      isShowingPlateDeleteDialog: false,
      selectedPlate: {},
      plates: []
    };
  },
  computed: {
    headers() {
      return [
        {
          i18nText: 'global.plate',
          text: this.$i18n.t('global.plate'),
          align: 'left',
          value: 'plate'
        },
        {
          i18nText: 'globa.alias',
          text: this.$i18n.t('global.alias'),
          align: 'right',
          value: ''
        },
        {
          i18nText: '',
          text: '',
          align: 'right',
          value: ''
        }
      ];
    }
  },
  mounted() {},
  created() {
    this.getuserPlates();
  },
  destroyed() {},
  methods: {
    async getuserPlates() {
      let params = {};
      let results = await plateService.list(params);

      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.plates = results.data;

      if (this.plates.length === 0) {
        this.hasRows = false;
      } else {
        this.hasRows = true;
      }
      this.loaded = true;
    },
    showPlateDeleteDialog(item) {
      this.isShowingPlateDeleteDialog = true;
      this.selectedPlate = item;
    },
    closePlateDeleteDialog() {
      this.isShowingPlateDeleteDialog = false;
      this.selectedPlate = {};
    },
    closePlateCreateBottomSheet() {
      this.isShowingPlateCreateBottomSheet = false;
    }
  }
};
</script>
